import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { antiFlashWhite, brandPrimary, header, label, successGreen, titles } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

const { spacing, common } = THEME;

export const styleSheet = StyleSheet.create({
	buttonContainer: {
		display: 'flex',
		gap: spacing.sm,
	},
	passwordButtonContainer: {
		display: 'flex',
		gap: spacing.sm,
		margin: `${spacing.md}px 0`,
	},
	header: {
		color: brandPrimary,
		fontSize: 18,
	},
	editUserPasswordInstructions: {
		color: label,
		fontSize: 14,
	},
	formFieldLabel: {
		color: header,
		display: 'flex',
		fontSize: 14,
		width: 200,
	},
	title: {
		color: titles,
		display: 'inline-block',
		fontSize: 18,
	},
	checkboxes: {},
	checkbox: {
		color: titles,
		fontSize: 14,
	},
	emailCheckbox: {
		marginBottom: spacing.sm,
	},
	body: {
		alignItems: 'center',
		display: 'flex',
		marginBottom: spacing.md,
		gap: 100,
	},
	pushCheckboxContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.sm,
	},
	smsInstructionsLabel: {
		color: header,
		fontSize: 14,
		marginBottom: spacing.md,
	},
	codeSent: {
		alignItems: 'center',
		background: antiFlashWhite,
		borderRadius: common.borderRadius,
		border: common.border,
		height: 26,
		width: 101,
		color: header,
		display: 'flex',
		fontSize: 12,
		padding: spacing.xs,
		...CssSelectors.allChildren({
			background: successGreen,
			borderRadius: '50%',
			display: 'inline-block',
			height: 18,
			marginRight: spacing.sm,
			position: 'relative',
			width: 18,
		}),
	},
	formValueNonEditable: {
		color: titles,
		fontSize: 14,
	},
	emailField: {
		display: 'inline-block',
		margin: `${spacing.sm}px 0`,
	},
	linkMargin: {
		marginLeft: spacing.md,
	},
	passwordRequirementItem: {
		marginBottom: spacing.sm,
	},
	codeChallengeContainer: {
		width: 300,
		justifyContent: 'space-between',
	},
});
